/**
 * ajax 请求的封装
 */
import qs from 'qs'
import axios from 'axios'
import toast from './toast'
import router from '../router'

export default {
  //
  baseUrl: window.location.protocol + '//' + window.location.host + '/' + (process.env.NODE_ENV === 'development' ? 'api/' : ''),
  // baseUrl: 'http://yxrsadmin.91cdkey.com//',

  // baseUrl: 'http://192.168.11.104:8080/',

  /** ****************新的，ajax方法，参数都在外部发起请求的时候配置******************/
  /*
      诸如
    * {url:'xxx',method:'get',contentType:'xxx',successFunc:function(),errorFunc:function()}
    *
    * */
  fetch(request) {
    let config = this.configFetchConfig(request);
    let that = this;
    axios
      .request(config)
      .then(function (response) {
        toast.hide()
        that.checkResponse(response, request.successFunc, request.errorFunc, request.errorGoOnFunc)
      })
      .catch(function (error) {
        toast.hide()
      })
  },

  configFetchConfig(request) {
    let requestMethod = 'get'
    requestMethod = request.method
      ? request.method
      : 'get'
    if (request.disableLoading && request.disableLoading == true) {
    } else {
      toast.loading()
    }

    let requestUrl = this.baseUrl + request.url
    let contentType = request.contentType
      ? request.contentType
      : requestMethod !== "get" ? 'application/x-www-form-urlencoded; charset=UTF-8' : "";

    if (request.isFile) {
      contentType = 'multipart/form-data';
    }

    let config = {
      method: requestMethod,
      url: requestUrl,
      headers: {
        'content-type': contentType
      },
      timeout: 80000
    }
    if ((requestMethod === 'post' || requestMethod === 'put') && !request.isFile) {
      if (request.transferJson) {
        config.data = JSON.stringify(request.param)
      } else {
        config.data = qs.stringify(request.param)
      }
    } else {
      config.params = request.param
    }
    return config
  },

  // 校验code并处理下一步操作
  checkCode(code, errorFunc, res) {
    code += '';
    let text = '';
    switch (code) {
      case '300':
        text = '连接超时';
        break;
      case '500':
        text = '服务器异常';
        break;
      case '401':
        text = '重新登录';
        router.replace('login');
        return;
      default:
        if (errorFunc != null) {
          errorFunc(res.data)
        } else {
          let msg = res.data.info
          if (msg != null || msg.length >= 0) {
            toast.showWarning(msg)
          }
        }
        return
    }

    toast.showWarning(text)
    return false;
  },

  checkResponse(res, responseFunc, errorFunc, errorGoOnFunc) {
    let code = res.data.code
    if (res.data.status == '1') {
      if (code == '200') {
        responseFunc(res.data.data)
      } else {
        this.checkCode(code, errorFunc, res);
      }
    } else {
      typeof errorGoOnFunc === 'function' && errorGoOnFunc(res.data);
      this.checkCode(code, errorFunc, res);
    }
  },
  /**
   * 上传文件
   * @param request
   */
  // upload(request) {
  //   toast.loading()
  //   this.client.put(request.fileName, request.file).then(res => {
  //     request.responseFunc(res)
  //     toast.hide()
  //   }).catch(error => {
  //     toast.hide()
  //     toast.showWarning(error)
  //   })
  //
  // },

  // upload(url, files, responseFunc, errFunc, isNoCheck) {
  //   let form = new FormData();
  //   if (files) {
  //     form.append("fileName", files);
  //   }
  //   if (isNoCheck) {
  //     form = files;
  //   }
  //   toast.loading();
  //   axios.post(this.baseUrl + url, form, {
  //     method: "post",
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //     timeout: 80000
  //   }).then((response) => {
  //     toast.hide();
  //     this.checkResponse(response, responseFunc, errFunc);
  //   }).catch((error) => {
  //     toast.hide();
  //     if (errFunc !== null) {
  //       errFunc(error);
  //     }
  //   })
  // },
  upload(data) {
    let form = new FormData();

    for (let i in data.param) {
      form.append(i, data.param[i])
    }

    if (!data.successFunc) data.successFunc = () => {
    }
    if (!data.errFunc) data.errFunc = () => {
    }

    let that = this

    axios.post(this.baseUrl + data.url, form, {
    // axios.post(data.url, form, {
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 80000
    }).then((response) => {
      // toast.hide();
      that.checkResponse(response, data.successFunc, data.errFunc, data)
    }).catch((error) => {
      // toast.hide();
      if (data.errFunc !== null) {
        data.errFunc(error);
      }
    })
  },
  /*
     * 下载导出文件
     * */
  downLoad(url, param, responseFunc, errFunc) {
    var classSelf = this
    let method = 'get'

    let paramString = '?'
    for (let key in param) {
      paramString += `${key}=${param[key]}&`
    }
    param = (typeof paramString === 'string')
      ? paramString
      : JSON.stringify(paramString)


    var xhr = new XMLHttpRequest()
    let requestUrl = this.baseUrl + url
    if (param.length > 0) {
      requestUrl = requestUrl + paramString
    }
    xhr.open(method, requestUrl, true)
    xhr.responseType = 'blob'
    xhr.setRequestHeader('Content-Type', 'application/octet-stream;charset=UTF-8')

    xhr.onload = function (e) {
      if (this.status == 200) {
        var filename = ''
        var disposition = xhr.getResponseHeader('Content-Disposition')
        if (disposition && disposition.indexOf('attachment') !== -1) {
          console.log(disposition)
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          var matches = filenameRegex.exec(disposition)
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '')
          }
          console.log(filename)
          filename = decodeURI(filename)
        }
        var type = xhr.getResponseHeader('Content-Type')

        var blob = new Blob([this.response], {type: type})
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // IE workaround for "HTML7007: One or more blob URLs were revoked by closing
          // the blob for which they were created. These URLs will no longer resolve as the
          // data backing the URL has been freed."
          toast.hide()
          window
            .navigator
            .msSaveBlob(blob, filename)
        } else {
          var URL = window.URL || window.webkitURL
          var downloadUrl = URL.createObjectURL(blob)

          if (filename) {

            // use HTML5 a[download] atoast.hide();ttribute to specify filename
            var a = document.createElement('a')
            // safari doesn't support this yet
            if (typeof a.download === 'undefined') {
              window.location = downloadUrl
            } else {
              a.href = downloadUrl
              a.download = filename
              document
                .body
                .appendChild(a)
              a.click()
            }
          } else {
            toast.hide()
            window.location = downloadUrl
          }
          setTimeout(function () {
            URL.revokeObjectURL(downloadUrl)
          }, 100) // cleanup
        }
        if (!!responseFunc && typeof responseFunc == "function") {
          responseFunc();
        }
      } else {
        if (!!errFunc && typeof errFunc == "function") {
          errFunc();
        }
      }
    }
    xhr.send()
  }
}



// WEBPACK FOOTER //
// ./src/utility/ajax.js